import React, { forwardRef } from "react";
import { InputAdornment, TextField, TextFieldProps } from "@mui/material";
import CalendarCheckFillIcon from "remixicon-react/CalendarCheckFillIcon";
import dateformat from "dateformat";
import { useCommonStyles } from "$containers/CommonStyles/CommonStyles";

interface DateInputProps extends Omit<TextFieldProps, "onChange" | "value"> {
  startDate?: Date | null;
  endDate?: Date | null;
  onClear?: () => void;
  displayCalendarIcon?: boolean;
  variant?: "filled" | "outlined" | "standard";
  error?: boolean;
}

const DateInput = forwardRef<HTMLInputElement, DateInputProps>(
  (
    {
      startDate,
      endDate,
      onClear,
      label,
      displayCalendarIcon = true,
      variant = "outlined",
      error,
      ...props
    },
    ref
  ) => {
    const commonClasses = useCommonStyles();

    let inputDateValue = null;
    if (!inputDateValue && startDate) {
      inputDateValue = dateformat(startDate, "dd/mm/yyyy");
      if (endDate && startDate !== endDate) {
        inputDateValue += ` - ${dateformat(endDate, "dd/mm/yyyy")}`;
      }
    }

    return (
      <TextField
        ref={ref}
        value={inputDateValue}
        {...props}
        placeholder=" -- / -- / ----"
        className={[commonClasses.select].join(" ")}
        variant={variant || "outlined"}
        label={label}
        error={!!error}
        InputLabelProps={{
          shrink: true,
        }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              {displayCalendarIcon && (
                <CalendarCheckFillIcon
                  color="#646262"
                  style={{ marginLeft: "3px" }}
                />
              )}
            </InputAdornment>
          ),
        }}
      />
    );
  }
);

export default DateInput;
